import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import styled from "styled-components";

const Button = styled.button`
    width: 100%;
    background-color: #1e7e34;
`;


const AddElementButton = ({ onAddElementClick }) => {

    return (
        <Button
            onClick={onAddElementClick}
        >
            Add
        </ Button>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
    };
};

const mapDispatchToProps = {
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(AddElementButton));